import * as React from 'react';

export type LoadingProps = {
    classes: string
}

export const Loading = (props: React.PropsWithChildren<LoadingProps>) => (
    <div className={`${(props.classes && props.classes.length ? " " + props.classes : "")}`}>
        <span className="fa-solid fa-spinner fa-spin"></span>
    </div>
);